<template>
  <div class="page-content">
    <div class="page-title">Development Programme Strategic Plan 2022-2025</div>
    <div class="sub-title">Foreword</div>
    <div class="text">
      This is a critical moment for the world, and for development. A planetary emergency and the
      pandemic have depleted the world’s natural resources and widened poverty and inequality. Up to
      one billion people could be living in extreme poverty by 2030 unless we seize this opportunity
      for a decisive push towards the Sustainable Development Goals (SDGs).
      <br />
      But this is also a moment of choice: an opportunity to learn from our experience, to do things
      differently, to aspire to greater shared goals. This new Strategic Plan 2022-2025 describes
      how UNDP intends to work together with our partners to deliver what’s required of us in these
      extraordinary times. Collaborating across the revitalized UN system and beyond for stronger
      collective results. Applying integrated approaches aimed at transformative change. Supporting
      governments and communities to rebound from COVID-19 and build forward better.
      <br />
      The Strategic Plan is grounded in UNDP’s continued commitment to eradicating poverty,
      accompanying countries in their pathways towards the SDGs and working towards the Paris
      Agreement. It envisions bold goals, making a difference to millions of lives, including
      through tackling multidimensional poverty, energy access, elections participation and
      development financing. It explains how UNDP will develop our six signature solutions – powered
      by digitalisation, innovation and development financing – for greater impact. It sets out
      practical steps towards becoming an even more agile and anticipatory organisation, investing
      further in our people, business model and operational excellence.
      <br />
      The Plan describes how the combination of our deep local experience and our rich global
      network, tapping into countries’ knowledge and shared experience, delivers value to our
      partners. How we will foster innovation and creativity to help change systems and tackle the
      hardest challenges standing between us and the SDGs. All this to scale and accelerate progress
      towards green, inclusive transitions that empower every last person through greater
      opportunity and resilience.
      <br />
      The Plan is the result of extensive collaboration with our many partners. I am immensely
      grateful to them, and to all our UNDP teams, whose contributions have helped produce a Plan
      that truly reflects the diversity of all the countries, communities and people whom UNDP
      serves. I invite you to read the Plan itself and learn more.
      <br />
      With your support and collaboration, together UNDP can work with countries to expand people’s
      choices for a fairer, sustainable future, to build the world envisioned by Agenda 2030 with
      planet and people in balance.
    </div>
    <div class="more-btn">Read more <i class="el-icon-right"></i></div>
  </div>
</template>
<script>
export default {
  name: "strategy",
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.page-content {
  .page-title {
    font-weight: bold;
    font-size: fh(36vh, pc);
    color: #333333;
    line-height: fh(54vh, pc);
    text-align: justify;
    margin-bottom: fh(20vh, pc);
  }
  > img {
    width: 100%;
    display: block;
  }
  .sub-title {
    margin: fh(20vh, pc) 0;
    font-size: fh(24vh, pc);
    line-height: fh(54vh, pc);
    font-weight: bold;
    color: #333333;
  }
  .text {
    // margin-top: fh(55vh, pc);
    font-size: fh(18vh, pc);
    color: #2a2a2a;
    line-height: fh(31vh, pc);
  }
  .more-btn {
    margin: fh(50vh, pc) auto;
  }
}
</style>
